import { useHorizontalScrollForDesktop } from '@hooks/ocs/useDragingScrollSlider';
import { CSSProperties, ReactNode, useEffect } from 'react';

type ScrollSliderProps = {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
  scrollToX?: number;
  scrollToStart?: boolean;
};

function ScrollSlider({
  children,
  style,
  scrollToX,
  className = '',
  scrollToStart,
}: ScrollSliderProps) {
  const { targetComponentRef } = useHorizontalScrollForDesktop();
  useEffect(() => {
    if (scrollToX && scrollToX < 0) {
      const targetComponent = targetComponentRef?.current;
      targetComponent?.scrollTo(scrollToX, 0);
    }
  }, [scrollToX]);

  useEffect(() => {
    if (scrollToStart) {
      const target = targetComponentRef?.current;
      if (target) {
        target.scrollTo({ left: 0, behavior: 'smooth' });
      }
    }
  }, [scrollToStart]);
  return (
    <div
      ref={targetComponentRef}
      style={style}
      className={`${className} overflow-x-auto hidden-scroll-bar flex w-full [&_>div]:flex-none`}
    >
      {children}
    </div>
  );
}

export default ScrollSlider;
